import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import cx from 'classnames';
import { FontIcon } from 'react-toolbox';
import { isOverdue } from '../../../utils/dateUtils';
import S from './styles.scss';

const DueDate = ({ date, showText, className, isPhaseDetails }) => {
  const m = moment(date);
  const overdue = isOverdue(m);
  return (
    <span className={cx(S.due, className, { [S.overdue]: overdue && isPhaseDetails })}>
      <FontIcon value={overdue ? 'notifications_active' : 'notifications_none'} />
      {showText && 'Due: '}
      {m.isValid() ? <time dateTime={m.toISOString()}>{m.calendar()}</time> : '--'}
    </span>
  );
};

DueDate.propTypes = {
  date: PropTypes.string,
  className: PropTypes.string,
  showText: PropTypes.bool,
  isPhaseDetails: PropTypes.bool,
};

DueDate.defaultProps = {
  showText: true,
};

export default DueDate;



// WEBPACK FOOTER //
// ./client/app/shared/components/DueDate/index.jsx